<template>
  <div id="InjMold-view">
    <dv-full-screen-container>
      <div class="block-top-header">
        <div style="width: 40%">
          <top-header
            name="topHeader"
            :PageTitle="PageTitle"
            ActiveMenuIndex="InjMold"
          />
        </div>
      </div>
      <div class="block-top-content" style="width:100%;height:100%;">
      <el-tabs type="border-card" style="height: 1000px; width: 100%">
        <el-tab-pane style="width:100%;height:100%">
          <span slot="label"><i class="el-icon-date"></i> 利用率</span>
          <rate ref="rateComponent" ></rate>
        </el-tab-pane>
        <el-tab-pane label="峰平谷">
            <pvf1 ref="pvf1Component"></pvf1>
        </el-tab-pane>
        <el-tab-pane label="KPI">
           <kpi1 ref="kpi1Component"></kpi1>
        </el-tab-pane>
      </el-tabs>
      </div>
    </dv-full-screen-container>
  </div>
</template>
<script>
import kpi1 from "./kpi1.vue";

import rate from "./rate.vue";
import pvf1 from "./pvf1.vue";
import topHeader from "../TopMenu/topHeader.vue";
import request from "@/utils/request";
import echarts from "echarts";
import { AREA_LIST, BU_LIST } from "../mainPage/area_bu";
export default {
  name: "InjMold",
  components: {
    topHeader,
    kpi1,
    rate,
    pvf1,
  },
  data() {
    return {
      activeName: "first",
      PageTitle: "搪塑线对标",
      DataList: {},
      AreaList: AREA_LIST,
      BUList: BU_LIST,
      selectedArea: "GLOBAL",
      selectedBU: "",
      selectedPlant: "",
      selectedBranch: "",
      selectedTon: "",
      selectedEquipment: "",
      selectedDateRange: "",
      selectedFilterBy: "",
      activeChartGroup: "chart",
      activeCategory: "rate",
      activeColumnGroup: "energy",
      selectedFilterOrder: "desc",
      FilterNumber: "10",
      FilterList: [],
      PlantList: [],
      BranchList: [],
      TonList: [],
      EquipmentList: [],
      CurrentEquipmentList: [],
      tableData_kpi: [],
      tableData_kpi_detail: [],
      tableData_rate: [],
      tableData_rate_detail: [],
      tableData_pvf: [],
      tableData_pvf_detail: [],
      FilterListCategory: {
        kpi: [
          { value: "kpi_minute", label: "分钟单耗" },
          { value: "kpi_kg", label: "公斤单耗" },
          { value: "kpi_mold", label: "模单耗" },
        ],
        rate: [
          { value: "rate_cost", label: "能源利用率" },
          { value: "rate_time", label: "时间利用率" },
        ],
        pvf: [
          { value: "pvf_peak", label: "峰时占比" },
          { value: "pvf_flat", label: "平时占比" },
          { value: "pvf_valley", label: "谷时占比" },
          { value: "pvf_avg_cost", label: "均价" },
        ],
      },
      FilterOrder: [
        { value: "desc", label: "从大到小" },
        { value: "asc", label: "从小到大" },
      ],
    };
  },
};
</script>

<style lang="less">
#InjMold-view {
  width: 100%;
  height: 100%;
  background-color: #1B2445;
  color: #fff;
  #dv-full-screen-container {
    background-image: url("");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .el-tab-pane{
    width:100%;
    height:100%;
  }
  .block-top-header {
    width: 100%;
    display: flex;
    background-color: #1B2445;
  }
  .block-top-line {
    background-color: #313C5E;
    width: 100%; 
    height: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-mid {
    height: 5%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 100%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content-1 {
    flex: 1;
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-button {
    height: 5%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .pingpu {
    display: flex;
  }
  .dddss {
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-button-field {
    background-color: #1B2445;
    margin-top: 15px;
    margin-left: 10px;
  }
  .el-select .el-input__inner {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    color: #ffffff;
    font-size: 22px;
  }
  .el-date-editor el-range-editor el-input__inner el-date-editor--daterange {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    color: #ffffff;
  }
  .el-range-input {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    font-size: 22px;
  }
  .el-tag.el-tag--info {
    display:none !important;
  }
  .el-tabs--border-card>.el-tabs__content{
    height:100%;
    width:100%;
    padding: 0px;
  }
}
</style>
